import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useHangyeTypeUpdateQuery,useHangyeTypeUpdateSaveMutation} from '../../store/dianshangtaizhangApi';
function TradeEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bg_content:''
    }); 
    const {data,isSuccess} = useHangyeTypeUpdateQuery({hyt_id:props.hyt_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    hyt_name:data.Result.hyt_name,
                })
                setInfo(prevState=>({...prevState,
                    hyt_name:data.Result.hyt_name,                  
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useHangyeTypeUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改行业'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "hyt_id" : props.hyt_id,
                        "hyt_name" : info.hyt_name,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="hyt_name" label='名称' wrapperCol={{span:10}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,hyt_name:e.target.value}))}}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default TradeEdit